import { AlternativesCards } from "@components/alternatives/AlternativesCards";
import { Herosection } from "@components/alternatives/HeroSection";
import AwardsSection from "@components/new-ui/AwardsSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import NewLayout from "@components/new-ui/Layout";
import TestimonialSection from "@components/new-ui/TestimonialSection";
import { alternativesCardsDetails, herosectionData } from "../../components/alternatives/constant";

const index: React.FC = () => {
    return (
        <NewLayout
            title="Best Gallabox Alternatives & Competitors in 2025"
            description="Discover the top Gallabox alternatives in 2025! Compare the best conversational AI tools for WhatsApp marketing, lead generation, and CRM integration"
            canonical="https://gallabox.com/alternatives"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/alternatives/alternatives-og.png" }}
        >
            <Herosection {...herosectionData} />
            <section className={`${container_classname} my-10`}>
                <h3 className="text-center text-lg font-normal py-5">TRUSTED BY 10,000+ BUSINESSES</h3>
                <ClientLogos />
            </section>

            <section className="bg-gray-100 md:py-20 py-10">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 max-w-7xl mx-auto gap-y-10">
                    {alternativesCardsDetails.map((data, idx) => (
                        <AlternativesCards key={idx} {...data} />
                    ))}
                </div>
            </section>
            <TestimonialSection />
            <AwardsSection />
            <CTASection title="Turn connections into conversions" description="Take Gallabox for a 7-day ride" />
        </NewLayout>
    );
};

export default index;
